module.exports = __webpack_public_path__ + "static/img/1.49e41bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/1.jpg
// module id = AZnb
// module chunks = 6